<template>
  <div class="">
    <!-- 筛选区域 -->
    <div class="filter-section">
      <div>
        <div class="opport-screen-list1">
          <dl class="opport-screen bdbe">
            <dt class="fl">区域类型</dt>
            <dd class="fl">
              <span :key="index" v-for="(item, index) in dataTypeList"
                :class="dataType == item.id ? 'a-screen current' : 'a-screen'" @click="hanlderDataType(item.id)">{{
                  item.name
                }}</span>
            </dd>
          </dl>
          <dl class="opport-screen bdbe" v-show="dataType == 2">
            <dt class="fl">区域范围</dt>
            <dd class="fl">
              <span @click="areaChange('all')"
                :class="searchFilter.areaCode == 'all' ? 'a-screen current' : 'a-screen'">全部</span>
              <span :key="index" v-for="(item, index) in areaList"
                :class="searchFilter.areaCode == item.code ? 'a-screen current' : 'a-screen'"
                @click="areaChange(item.code)">{{ item.name }}</span>
            </dd>
          </dl>
          <dl class="opport-screen bdbe">
            <dt class="fl">时间类型</dt>
            <dd class="fl">
              <span :key="index" v-for="(item, index) in showDataTimeList"
                :class="dataTime == item.id ? 'a-screen current' : 'a-screen'" @click="hanlderDataTime(item.id)">{{
                  item.name
                }}</span>
              <el-date-picker class="ml-2" v-model="yearRange" type="monthrange" value-format="yyyy" align="right"
                popper-class="date-right" unlink-panels range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期" :picker-options="pickerOptions" @change="yearRangeChange">
              </el-date-picker>
            </dd>
          </dl>
          <dl class="opport-screen bdbe">
            <dt class="fl">指标选择</dt>
            <dd class="fl indicator-select-dd" v-if="categoriesList && categoriesList.length > 0">
              <el-row :gutter="16">
                <el-col :span="colSpan" :key="index" v-for="(item, index) in categoriesList">
                  <span :class="categories == item.category_id ? 'a-screen current' : 'a-screen'"
                    @click="selectCategorie(item)">{{ item.name }}</span>
                </el-col>
              </el-row>

            </dd>
            <p v-else>暂无指标</p>
          </dl>
          <dl class="opport-screen bdbe indicator-select-row" v-show="categoriesList2 && categoriesList2.length > 0">
            <dt class="fl">具体指标</dt>
            <dd class="fl indicator-select-dd">
              <span :key="index" v-for="(item, index) in categoriesList2" @click="selectCategorie2(item)"
                :class="categories2 == item.category_id ? 'a-screen current' : 'a-screen'">{{ item.name }}</span>
            </dd>
          </dl>
          <!-- 新增：指标筛选，areaCode === 'all' 时显示 -->
          <dl class="opport-screen bdbe indicator-select-row"
            v-show="searchFilter.areaCode === 'all' && dataType == 2 && indicatorsList && indicatorsList.length > 0">
            <dt class="fl">指标筛选</dt>
            <dd class="fl indicator-select-dd">
              <el-row :gutter="16">
                <el-col :span="colSpanIndicators" :key="index" v-for="(item, index) in indicatorsList">
                  <span :class="curIndicatorId == item.indicator_id ? 'a-screen current' : 'a-screen'"
                    @click="indicatorsListChange(item)">{{ item.show_name }}</span>
                </el-col>
              </el-row>

            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dataInJs } from '@/utils/city.js';
export default {
  name: 'filterCom',
  components: {
  },
  data() {
    return {
      dataTypeList: [{ id: 1, name: '全国数据', areaType: "nation" }, { id: 2, name: '省份数据', areaType: "province" }],
      dataType: 1,
      dataTimeList: [{ id: 1, name: '季度数据', periodType: "quarter" }, { id: 2, name: '月度数据', periodType: "month" }, { id: 3, name: '年度数据', periodType: "year" }],
      dataTime: 1,
      categoriesList: [{ id: 1, name: '项目数', children: [{ id: 1, name: '项目数2' }] }, { id: 2, name: '投资金额' }, { id: 3, name: '投资占比' }, { id: 4, name: '投资占比排名' }, { id: 5, name: '投资占比排名' }, { id: 6, name: '投资占比排名' }, { id: 7, name: '投资占比排名' }],
      categories: 1,
      categoriesList2: [],
      categories2: 1,
      yearRange: [],
      indicatorsList: [],
      pickerOptions: null,
      pickerOptionsMonth: {
        shortcuts: [{
          text: '今年',
          onClick(picker) {
            const year = new Date().getFullYear();
            picker.$emit('pick', [new Date(year, 0), new Date(year, 0)]);
          }
        }, {
          text: '最近3年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setFullYear(start.getFullYear() - 2);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近5年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setFullYear(start.getFullYear() - 4);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      pickerOptionsQuarter: {
        shortcuts: [{
          text: '最近3年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setFullYear(start.getFullYear() - 2);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近5年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setFullYear(start.getFullYear() - 4);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近10年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setFullYear(start.getFullYear() - 9);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近15年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setFullYear(start.getFullYear() - 14);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      pickerOptionsYear: {
        shortcuts: [{
          text: '最近3年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setFullYear(start.getFullYear() - 2);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近5年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setFullYear(start.getFullYear() - 4);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近10年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setFullYear(start.getFullYear() - 9);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      areaList: [],
      searchFilter: {
        indicatorId: '',
        areaCode: 'all',
        startYear: '',
        endYear: '',
      },
      tableData: [],
      tableMap: {},
      tableYears: [],
      currentIndicatorIds: [],
      curIndicatorId: '',
      loadedCount: 0,
      colSpanIndicators: 0
    }
  },
  props: {
    pageType: {
      type: Number,
      default: 1
    }
  },
  computed: {
    showDataTimeList() {
      if (this.pageType === 1) {
        this.dataTime = 1;
        return this.dataTimeList.filter(
          item => item.id === 1 || item.id === 3
        );
      }
      if (this.pageType === 2 || this.pageType === 3) {
        this.dataTime = 2;
        return this.dataTimeList.filter(
          item => item.id === 2 || item.id === 3
        );
      }
      return this.dataTimeList;
    },
    colSpan() {
      const maxLen = Math.max(...this.categoriesList.map(item => item.name.length));
      // 字数多(>=8) → 2列(span=12)，中等(>=5) → 3列(span=8)，少 → 4列(span=6)
      if (maxLen >= 28) return 12;
      if (maxLen >= 25) return 8;
      if (maxLen >= 18) return 6;
      if (maxLen >= 6) return 4;
      return 6;
    },

  },
  watch: {
    pageType(val) {
      console.log('pageType', val);
      //清空数据，重新加载指标分类
      // 清空旧数据，重新加载当前所有指标
      this.dataTime = 1;
      this.dataType = 1;
      this.categories = 1;
      this.categories2 = 1;
      this.categoriesList2 = [];
      this.indicatorsList = [];
      this.searchFilter.indicatorId = '';
      this.searchFilter.areaCode = '';
      this.searchFilter.startYear = '';
      this.searchFilter.endYear = '';
      this.tableData = [];
      this.tableMap = {};
      this.tableYears = [];
      this.loadedCount = 0;
      this.getCategories();
    }
  },
  mounted() {
    if (this.dataTime == 1) {
      this.pickerOptions = this.pickerOptionsQuarter;
    } else if (this.dataTime == 2) {
      this.pickerOptions = this.pickerOptionsMonth;
    } else if (this.dataTime == 3) {
      this.pickerOptions = this.pickerOptionsYear;
    }
    this.getAreas();
    this.getCategories();
  },

  methods: {
    colSpanIndicatorsFun() {
      const maxLen = Math.max(...this.indicatorsList.map(item => item.show_name.length));
      // 字数多(>=8) → 2列(span=12)，中等(>=5) → 3列(span=8），少 → 4列(span=6)
      if (maxLen >= 28) return 12;
      if (maxLen >= 25) return 8;
      if (maxLen >= 18) return 6;
      if (maxLen >= 6) return 4;
      return 6;
    },
    // 切换区域类型
    hanlderDataType(id) {
      this.dataType = id;

      if (this.dataType == 1) {
        this.searchFilter.areaCode = '';
      }
      // if (this.dataType == 2 && this.areaList.length > 0) {
      //   this.searchFilter.areaCode = this.areaList[0].code;
      // }

      this.getCategories();
    },

    // 切换时间类型
    hanlderDataTime(id) {
      this.dataTime = id;
      if (this.dataTime == 1) {
        this.pickerOptions = this.pickerOptionsQuarter;
      } else if (this.dataTime == 2) {
        this.pickerOptions = this.pickerOptionsMonth;
      } else if (this.dataTime == 3) {
        this.pickerOptions = this.pickerOptionsYear;
      }
      this.getCategories();
    },

    // ← 修改：日期范围变化时重新获取数据
    yearRangeChange(val) {
      console.log('yearRangeChange', val);
      this.searchFilter.startYear = val && val[0] ? val[0] : '';
      this.searchFilter.endYear = val && val[1] ? val[1] : '';

      // 清空旧数据，重新加载当前所有指标
      this.tableData = [];
      this.tableMap = {};
      this.tableYears = [];
      this.loadedCount = 0;

      if (this.indicatorsList && this.indicatorsList.length > 0) {
        if (this.searchFilter.areaCode === 'all' && this.dataType == 2) {
          // 全部省份：只加载当前选中的指标
          var target = this.indicatorsList.find(function (item) {
            return item.indicator_id === this.curIndicatorId;
          }.bind(this)) || this.indicatorsList[0];
          // this.curIndicatorId = target.indicator_id;
          this.getDataValues(target.indicator_id, target.show_name);
        } else {
          this.indicatorsList.forEach((item) => {
            this.getDataValues(item.indicator_id, item.show_name);
          });
        }
      } else {
        this.getCategories();
      }
    },

    // 选择一级指标
    selectCategorie(item) {
      console.log('selectCategorie', item, this.categories === item.category_id);
      if (this.categories === item.category_id) return;

      this.categories = item.category_id;
      this.categoriesList2 = item.children || [];

      // ← 修改：默认选择二级指标第一项
      if (this.categoriesList2 && this.categoriesList2.length > 0) {
        // this.categories2 = this.categoriesList2[0].category_id;
        this.selectCategorie2(this.categoriesList2[0]);
      } else {
        this.categories2 = '';
      }

      this.tableData = [];
      this.tableMap = {};
      this.tableYears = [];
      this.loadedCount = 0;

      this.currentIndicatorIds = item.children
        ? item.children.map(i => i.indicator_id)
        : [item.indicator_id];

      this.getIndicators(item.category_id);
    },

    // ← 新增：选择二级指标
    selectCategorie2(item) {
      console.log('selectCategorie2', item, this.categories2 === item.category_id);
      if (this.categories2 === item.category_id) return;
      this.categories2 = item.category_id;

      // 清空旧数据，重新加载
      this.tableData = [];
      this.tableMap = {};
      this.tableYears = [];
      this.loadedCount = 0;

      // if (this.indicatorsList && this.indicatorsList.length > 0) {
      // this.indicatorsList.forEach((indicator) => {
      this.getIndicators(item.category_id);
      //   });
      // }
    },

    // ← 新增：指标筛选切换（areaCode === 'all' 时使用）
    indicatorsListChange(item) {
      console.log('indicatorsListChange', item, this.curIndicatorId === item.indicator_id);
      if (this.curIndicatorId === item.indicator_id) return;

      this.tableData = [];
      this.tableMap = {};
      this.tableYears = [];
      this.loadedCount = 0;
      this.curIndicatorId = item.indicator_id;
      this.getDataValues(item.indicator_id, item.show_name);
    },

    getIndicators(categorieId) {
      this.$emit('getLoading', true);
      let ajaxUrl = this.$api.common.ConstructionIndustry.Indicators() + '?categoryId=' + categorieId;
      this.$axios.get(ajaxUrl).then((res) => {
        console.log('指标列表', res);
        this.indicatorsList = res.list;
        this.colSpanIndicators = this.colSpanIndicatorsFun();
        if (!this.indicatorsList || this.indicatorsList.length === 0) {
          this.tableData = [];
          this.tableYears = [];
          this.$emit('getTableData', [], []);
          this.$emit('getLoading', false);
          return;
        }

        if (this.searchFilter.areaCode === 'all' && this.dataType == 2) {
          // ← 新增：全部省份时，默认加载第一个指标
          this.curIndicatorId = this.indicatorsList[0].indicator_id;
          this.getDataValues(this.indicatorsList[0].indicator_id, this.indicatorsList[0].show_name);
        } else {
          this.indicatorsList.forEach((item) => {
            this.getDataValues(item.indicator_id, item.show_name);
          });
        }
      }).catch((err) => {
        this.tableData = [];
        this.tableYears = [];
        this.$emit('getTableData', [], []);
        this.$emit('getLoading', false);
      })
    },

    getDataValues(indicatorId, showName = '') {
      this.searchFilter.indicatorId = indicatorId;
      //判断参数是否为空或者all
      let params = { ...this.searchFilter };
      if (this.dataType == 1) {
        for (let key in params) {
          if (!params[key] || params[key] === 'all') {
            delete params[key];
          }
        }
      }
      let ajaxUrl = this.$api.common.ConstructionIndustry.DataValues();
      this.$axios.get(ajaxUrl, { params }).then((res) => {
        // this.curIndicatorId = this.searchFilter.indicator_id;
        if (this.searchFilter.areaCode === 'all' && this.dataType == 2) {
          // ← 新增：全部省份时，res.list 为 [{area, name, list: [时间序列]}, ...]
          if (res.data && Array.isArray(res.data) && res.data.length > 0) {
            this.flattenAllAreaData(res.data, indicatorId, showName);
          }
        } else {
          if (res.list && Array.isArray(res.list) && res.list.length > 0) {
            this.flattenData(res.list, indicatorId, showName);
          }
        }


        this.loadedCount++;
        this.checkAllIndicatorLoaded();
      }).catch((err) => {
        console.error(err);
        this.loadedCount++;
        this.checkAllIndicatorLoaded();
      })
    },

    checkAllIndicatorLoaded() {
      // ← 修改：全部省份时只等待1个请求，单个省份时等待所有指标
      var targetCount = (this.searchFilter.areaCode === 'all' && this.dataType == 2) ? 1 : this.indicatorsList.length;
      if (this.loadedCount >= targetCount) {
        this.buildTableData();
      }
    },

    buildTableData() {
      // 【修复】使用正确的时间排序，字符串不能用减法
      this.tableYears.sort((a, b) => {
        const yearA = a.substring(0, 4);
        const yearB = b.substring(0, 4);

        // 先按年份倒序（新的在前）
        if (yearA !== yearB) {
          return parseInt(yearB) - parseInt(yearA);
        }

        // 同年份按周期倒序
        if (a.includes('季度')) {
          const order = { '一': 1, '二': 2, '三': 3, '四': 4 };
          const qa = a.match(/第(.)季度/);
          const qb = b.match(/第(.)季度/);
          return (qb ? order[qb[1]] : 0) - (qa ? order[qa[1]] : 0);
        } else if (a.includes('月')) {
          const ma = a.match(/(\d+)月/);
          const mb = b.match(/(\d+)月/);
          return (mb ? parseInt(mb[1]) : 0) - (ma ? parseInt(ma[1]) : 0);
        }
        return b.localeCompare(a);
      });

      var list = [];
      for (var key in this.tableMap) {
        if (this.tableMap.hasOwnProperty(key)) {
          list.push(this.tableMap[key]);
        }
      }

      if (list.length === 0) {
        this.tableData = [];
        this.tableYears = [];
      } else {
        this.tableData = list;
      }

      this.$emit('getTableData', this.tableData, this.tableYears);
      this.$emit('getLoading', false);
    },

    // ← 新增：处理"全部省份"返回的数据结构
    // 数据格式：[{area: '110000', name: '北京', list: [{period_name: '2026年第一季度', value: 123}, ...]}, ...]
    flattenAllAreaData(data, indicatorId, showName = '') {
      for (var i = 0; i < data.length; i++) {
        var areaItem = data[i];
        var rowKey = areaItem.area || areaItem.name || ('row_' + i);

        if (!this.tableMap[rowKey]) {
          this.tableMap[rowKey] = {
            indicatorId: rowKey,
            indicatorName: areaItem.name == '000000000000' ? '全国' : areaItem.name || ''
          };
        }

        // 每个省份下的时间序列
        if (areaItem.list && Array.isArray(areaItem.list)) {
          for (var j = 0; j < areaItem.list.length; j++) {
            var timeItem = areaItem.list[j];
            this.tableMap[rowKey][timeItem.period_name] = timeItem.value;

            if (!this.tableYears.includes(timeItem.period_name)) {
              this.tableYears.push(timeItem.period_name);
            }
          }
        }
      }
    },

    flattenData(data, indicatorId, showName = '') {
      const rowKey = indicatorId;

      if (!this.tableMap[rowKey]) {
        this.tableMap[rowKey] = {
          indicatorId,
          indicatorName: ''
        };
      }

      const first = data[0];
      const name = showName || first.indicatorName + (first.unit ? `(${first.unit})` : '');
      this.tableMap[rowKey].indicatorName = name;

      for (let i = 0; i < data.length; i++) {
        const item = data[i];
        this.tableMap[rowKey][item.period_name] = item.value;

        if (!this.tableYears.includes(item.period_name)) {
          this.tableYears.push(item.period_name);
        }
      }
    },

    getCategories() {
      let ajaxUrl = this.$api.common.ConstructionIndustry.Categories() + '?type=' + this.pageType;
      this.$axios.get(ajaxUrl).then((res) => {
        console.log('指标分类', res);
        var list = this.filterCategories(res.list);
        this.categoriesList = list;

        if (list.length > 0) {
          this.selectCategorie(list[0]);
        } else {
          this.tableData = [];
          this.tableYears = [];
          this.$emit('getTableData', [], []);
          this.$emit('getLoading', false);
        }
      }).catch((err) => {
        console.error(err);
        this.tableData = [];
        this.tableYears = [];
        this.$emit('getTableData', [], []);
        this.$emit('getLoading', false);
      });
    },

    getAreas() {
      let ajaxUrl = this.$api.common.ConstructionIndustry.Areas();
      this.$axios.get(ajaxUrl).then((res) => {
        console.log('城市', res);
        this.areaList = res.list;
      }).catch((err) => {
      })
    },

    filterCategories(categories) {
      var selectedAreaType = ''
      var selectedPeriodType = ''

      var areaItem = this.dataTypeList.find(function (item) {
        return item.id === this.dataType
      }.bind(this))

      var timeItem = this.dataTimeList.find(function (item) {
        return item.id === this.dataTime
      }.bind(this))
      console.log('areaItem', areaItem, 'timeItem', timeItem);
      if (areaItem) {
        selectedAreaType = areaItem.areaType
      }

      if (timeItem) {
        selectedPeriodType = timeItem.periodType
      }
      console.log('selectedAreaType', selectedAreaType, 'selectedPeriodType', selectedPeriodType);
      if (!selectedAreaType || !selectedPeriodType) {
        return []
      }

      var matchedItems = categories.filter(function (item) {
        console.log('item', item);
        return (
          item.areaType === selectedAreaType &&
          item.periodType === selectedPeriodType
        )
      })
      console.log('matchedItems', matchedItems);
      var childrenList = []
      for (var i = 0; i < matchedItems.length; i++) {
        var children = matchedItems[i].children
        if (Array.isArray(children)) {
          for (var j = 0; j < children.length; j++) {
            childrenList.push(children[j])
          }
        }
      }
      console.log('childrenList', childrenList);
      return childrenList
    },

    // 切换省份
    areaChange(val) {
      console.log('省市区切换', val);
      if (this.searchFilter.areaCode === val) return;
      this.searchFilter.areaCode = val;

      this.tableData = [];
      this.tableMap = {};
      this.tableYears = [];
      this.loadedCount = 0;

      if (this.indicatorsList && this.indicatorsList.length > 0) {
        if (this.searchFilter.areaCode === 'all' && this.dataType == 2) {
          // ← 新增：全部省份时，只加载当前选中的指标
          var target = this.indicatorsList.find(function (item) {
            return item.indicator_id === this.curIndicatorId;
          }.bind(this)) || this.indicatorsList[0];
          // this.curIndicatorId = target.indicator_id;
          this.getDataValues(target.indicator_id, target.show_name);
        } else {
          this.indicatorsList.forEach((item) => {
            this.getDataValues(item.indicator_id, item.show_name);
          });
        }
      } else {
        this.getCategories();
      }
    },
  }
}
</script>

<style lang="less" scoped>
.project-approval-page {
  padding: 20px;
  background: #f5f7fa;

  .filter-section {
    background: #fff;
    border-radius: 0 0 8px 8px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);

    .opport-screen-list1 {
      .opport-screen {
        dd.date-picker-wrapper {
          min-width: 320px;
        }
      }
    }
  }
}
</style>